import { FC, useState, useEffect, Key, useRef } from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { ProModal, ProAlert, ProTag, ProButton, } from '../antd';
import SuperTable from '../SuperTable';
import { SuperTableProps } from '../SuperTable';
import { TableActionType } from '../SuperTable/interface';
import { ModalProps } from 'antd/lib/modal';
import { TableRowSelection, RowSelectionType } from 'antd/lib/table/interface';
import styles from './style.module.less';
import { ButtonType } from 'antd/lib/button';

enum SizeEnum {
  small = 600,
  middle = 850,
  large = 1100,
}
export type ModalTableType = 'middle' | 'large' | 'small' | false;
export interface NewModalProps extends Omit<ModalProps, 'onOk'> {
  onCancel?: () => void;
  onOk?: (selectedRowKeys?: Key[], selectedRows?: any[]) => void;
  /** 弹窗大小 */
  size?: ModalTableType;
  /** 是否隐藏确定按钮 */
  hideOkButton?: boolean;
  /** 是否隐藏取消按钮 */
  hideCancelButton?: boolean;
}
export interface IselectedInfo {
  selectedRowKeys?: Key[];
  selectedRows?: any[];
}
export interface NewSuperTableProps extends SuperTableProps {
  rowSelectionType?: RowSelectionType;
  selectedInfo?: IselectedInfo;
}
export interface ModalTableProps {
  /** 是否将已选项用tab标签展示 */
  hideTab?: boolean;
  /** label对应字段 */
  nameKey?: string;
  /** 清空后回调 */
  onEmpty?: () => void;
  /** modalProps */
  modalProps: NewModalProps;
  /** tableProps */
  tableProps: NewSuperTableProps;
}
/** 弹出表格 */
export const ModalTable: FC<ModalTableProps> = props => {
  const {
    nameKey,
    hideTab,
    onEmpty,
    modalProps: {
      onCancel,
      onOk,
      title = '查询',
      size = 'middle',
      width,
      open,
      visible,
      destroyOnClose,
      cancelText = '取消',
      cancelButtonProps,
      okText = '确定',
      okType = 'primary',
      okButtonProps,
      hideCancelButton,
      hideOkButton,
      confirmLoading,
      ...resModalProps
    },
    tableProps: {
      rowSelectionType,
      rowSelection,
      selectedInfo,
      operationProps,
      operation,
      rowKey,
      getCheckboxProps,
      ...resTableProps
    },
  } = props;
  const newOpen = open || visible;
  const actionRef = useRef<TableActionType>();
  const [modalWidth, setModalWidth] = useState<string | number | undefined>(
    width,
  );
  const [tableRowSelection, setTableRowSelection] = useState<
    TableRowSelection<any> | undefined
  >(rowSelection);
  const [selectedData, setSelectedData] = useState<IselectedInfo>({
    ...selectedInfo,
  });
  useEffect(() => {
    if (!newOpen && destroyOnClose) {
      setSelectedData({
        selectedRowKeys: [],
        selectedRows: [],
      });
    }
  }, [newOpen]);
  useEffect(() => {
    if (size) setModalWidth(SizeEnum[size]);
  }, [size]);
  useEffect(() => {
    setSelectedData({ ...selectedData, ...selectedInfo });
  }, [selectedInfo]);
  useEffect(() => {
    if (rowSelectionType) {
      setTableRowSelection({
        type: rowSelectionType,
        selectedRowKeys: selectedData?.selectedRowKeys,
        // onChange: (selectedRowKeys, selectedRows) => {
        //   setSelectedData({ selectedRowKeys, selectedRows });
        // },
        getCheckboxProps: getCheckboxProps ? (record: any) => {
          return getCheckboxProps(record);
        } : undefined,
        onSelect: (record: any, selected: boolean) => {
          const { selectedRowKeys = [], selectedRows = [] } = selectedData;
          const keyValue: string =
            typeof rowKey === 'string'
              ? record[rowKey]
              : rowKey?.(record) || record.key;
          if (selected) {
            if (rowSelectionType === 'checkbox') {
              setSelectedData({
                selectedRowKeys: [...selectedRowKeys, keyValue],
                selectedRows: [...selectedRows, record],
              });
            }
            if (rowSelectionType === 'radio') {
              setSelectedData({
                selectedRowKeys: [keyValue],
                selectedRows: [record],
              });
            }
          } else {
            setSelectedData({
              selectedRowKeys: selectedRowKeys.filter(v => v !== keyValue),
              selectedRows: selectedRows.filter(item => {
                const currentkeyValue: string =
                  typeof rowKey === 'string'
                    ? item[rowKey]
                    : rowKey?.(item) || item.key;
                return currentkeyValue !== keyValue;
              }),
            });
          }
        },
        onSelectAll: (selected, rows, changeRows) => {
          const { selectedRowKeys = [], selectedRows = [] } = selectedData;
          const changeRowsKeys: Key[] = changeRows.map(item => {
            const currentKey: string =
              typeof rowKey === 'string'
                ? item[rowKey]
                : rowKey?.(item) || item.key;
            return currentKey;
          });
          if (selected) {
            setSelectedData({
              selectedRowKeys: [...selectedRowKeys, ...changeRowsKeys],
              selectedRows: [...selectedRows, ...changeRows],
            });
          } else {
            setSelectedData({
              selectedRowKeys: selectedRowKeys.filter(
                v => !changeRowsKeys.includes(v),
              ),
              selectedRows: selectedRows.filter(item => {
                const currentkeyValue: string =
                  typeof rowKey === 'string'
                    ? item[rowKey]
                    : rowKey?.(item) || item.key;
                return !changeRowsKeys.includes(currentkeyValue);
              }),
            });
          }
        },
        ...rowSelection,
      });
    }
  }, [rowSelectionType, selectedData, rowSelection]);
  const handleEmpty = () => {
    setSelectedData({
      selectedRowKeys: [],
      selectedRows: [],
    });
    actionRef.current?.emptySelect();
    onEmpty?.();
  };
  // const handleFetchComplete = () => {
  //   setSelectedData({
  //     selectedRowKeys: [],
  //     selectedRows: [],
  //   });
  // };
  const handleOk = () => {
    // let keys: any[] | undefined = selectedData.selectedRowKeys;
    // let records: any[] | undefined = selectedData.selectedRows;
    // if (rowKey && typeof rowKey === 'string') {
    //   if (keys && keys.length && !records) {
    //     records = actionRef.current
    //       ?.getDataSource()
    //       .filter(v => keys?.includes(v[rowKey]));
    //   } else {
    //     records = records?.filter(v => keys?.includes(v[rowKey]));
    //   }
    // }
    const { selectedRowKeys = [], selectedRows = [] } = selectedData;
    onOk && onOk(selectedRowKeys, selectedRows);
  };
  const handleCancel = () => {
    onCancel && onCancel();
  };
  // tag关闭
  const handleClose = (key: string) => {
    const { selectedRowKeys, selectedRows } = selectedData;
    setSelectedData({
      selectedRowKeys: selectedRowKeys?.filter(v => v !== key),
      selectedRows: selectedRows?.filter(
        item => item[rowKey as string] !== key,
      ),
    });
  };
  return (
    <ProModal
      footer={[
        hideCancelButton ? null : <ProButton key='cancel' {...cancelButtonProps} onClick={handleCancel}>{cancelText}</ProButton>,
        hideOkButton ? null : <ProButton key='ok' type={okType as ButtonType} loading={confirmLoading} {...okButtonProps} onClick={handleOk}>{okText}</ProButton>,
      ]}
      {...resModalProps}
      open={newOpen}
      destroyOnClose={destroyOnClose}
      title={title}
      width={modalWidth}
      okButtonProps={{
        className: 'modal-table-ok-button',
      }}
      cancelButtonProps={{
        className: 'modal-table-cancel-button',
      }}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <SuperTable
        actionRef={actionRef}
        headOperation={false}
        toolBar={false}
        sceneType="modal"
        wrapperClassName='layout-table-column'
        rowSelection={tableRowSelection}
        operationProps={{ ...operationProps }}
        operation={operation || false}
        highSearch={true}
        rowKey={rowKey}
        // onFetchComplete={handleFetchComplete}
        headerTip={
          <>
            {rowSelectionType === 'checkbox' ? (
              <>
                <ProAlert
                  className={styles.alert}
                  message={
                    <>
                      <div className={styles.wrapper}>
                        <div>
                          <InfoCircleFilled className={styles.icon} />
                          {!!selectedData.selectedRowKeys?.length ? (
                            <>
                              <span>已选择</span>
                              <span className={styles.num}>
                                {selectedData.selectedRowKeys?.length}
                              </span>
                              <span>项</span>
                            </>
                          ) : (
                            <span className={styles.select}>请选择</span>
                          )}
                        </div>
                        <span
                          className={`${styles.empty} modal-empty-btn`}
                          onClick={handleEmpty}
                        >
                          清空
                        </span>
                      </div>
                    </>
                  }
                  type="info"
                />
                {!hideTab && !!nameKey && (
                  <div className={styles.tagWrapper}>
                    <span>已选项：</span>
                    {!selectedData.selectedRows?.length && <span>无</span>}
                    {selectedData.selectedRows?.map(item => {
                      const itemKey: string = item[rowKey as string];
                      return (
                        <ProTag
                          key={itemKey}
                          closable
                          onClose={e => {
                            e.preventDefault();
                            handleClose(itemKey);
                          }}
                        >
                          {item[nameKey]}
                        </ProTag>
                      );
                    })}
                  </div>
                )}
              </>
            ) : null}
          </>
        }
        {...resTableProps}
      />
    </ProModal>
  );
};

ModalTable.defaultProps = {
  hideTab: true,
};

export default ModalTable;
